class MatchModel {
    constructor(id, equipe1, equipe2, score1, score2, date) {
        this.id = id;
        this.equipe1 = equipe1;
        this.equipe2 = equipe2;
        this.score1 = score1;
        this.score2 = score2;
        this.date = date;
    }

    static fromJSON(json) {
        return new MatchModel(json.id, json.equipe1, json.equipe2, json.score1, json.score2, json.date);
    }
}

export default MatchModel;
